export default __webpack_public_path__ + "static/media/welcome-bg.e1787d42.webp";